import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getToken, setToken, removeToken } from "../../utils/auth";

// TypeScript interfaces
interface Admin {
  id: string;
  username: string;
  email: string;
  role: string;
  createdAt?: string;
  updatedAt?: string;
}

interface AdminProfile {
  id: string;
  username: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: string;
  createdAt: string;
  updatedAt: string;
}

interface AdminState {
  isLoggedIn: boolean;
  admin: Admin | null;
  token: string | null;
  isLoading: boolean;
  profile: AdminProfile | null;
}

const initialState: AdminState = {
  isLoggedIn: !!getToken(),
  admin: null,
  token: getToken(),
  isLoading: false,
  profile: null,
};

const adminReducerSlice = createSlice({
  name: "admins",
  initialState,
  reducers: {
    changeLoadingState: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setAdmin: (state, action: PayloadAction<Admin>) => {
      state.admin = action.payload;
    },
    setAdminLogin: (state, action: PayloadAction<string>) => {
      state.isLoggedIn = true;
      state.token = action.payload;
      state.isLoading = false;
      setToken(action.payload);
    },
    setAdminLogout: (state) => {
      removeToken();
      state.isLoggedIn = false;
      state.admin = null;
      state.token = null;
      state.profile = null;
      state.isLoading = false;
    },
    setAdminProfile: (state, action: PayloadAction<AdminProfile>) => {
      state.profile = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setAdmin,
  setAdminLogin,
  setAdminLogout,
  changeLoadingState,
  setAdminProfile,
} = adminReducerSlice.actions;

export default adminReducerSlice.reducer;

// Export types for use in other files
export type { Admin, AdminProfile, AdminState };
